import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
export enum FgCircleColor {
    BLUE = "blue-fg",
    GREY = "grey-fg"
}

export enum BgCircleColor {
    GREY1 = "grey-bg-1",
    GREY2 = "grey-bg-2"
}

export enum SpinnerBorderWidth {
    W1 = "border-width-1",
    W2 = "border-width-2"
}

export interface SpinnerOptions {
    borderWidth?: SpinnerBorderWidth,
    colorFg?: FgCircleColor,
    colorBg?: BgCircleColor
}

const defaultOptions = {
    borderWidth: SpinnerBorderWidth.W2,
    colorFg: FgCircleColor.GREY,
    colorBg: BgCircleColor.GREY1
}

@customElement('voyage-spinner')
export class VoyageSpinner extends LitElement
{
    @property({attribute: false}) transparent: boolean = false;
    @property({attribute: false}) options?: SpinnerOptions = defaultOptions;

    
    static get styles()
    {
        return [css`
            :host {
                display: block;
            }

            .container {
                animation: 1s cubic-bezier(.79,.26,.31,.7) 0s infinite running rotate-container;
                box-sizing: border-box;
                position: relative;
                width: 100%;
                height: 100%;
            }

            @keyframes rotate-container {
                from {
                    transform: rotate(-45deg);
                }
                to {
                    transform: rotate(315deg);
                }
            }

            .circle {
                position: absolute;
                border-radius: 50%;
                border: var(--voyage-spinner-stroke-width, 5px) solid;
                top: 0;
                bottom: -100%;
                left: -100%;
                right: 0;
                border-color: var(--neutrals-grey-05, grey);
            }

            .bg {
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
            }

            .circle[transparent] {
                border-color: var(--primary-blue-05, blue);
            }

            .bc {
                top: 0;
                bottom: -100%;
                left: -100%;
                right: 0;
                border-color: var(--primary-blue-05, blue);
            }

            .circleClipper {
                position: absolute;
                overflow: hidden;
                top: 0;
                right: 0;
                left: 50%;
                bottom: 50%;
            }

            /* ---- OPTIONS ---- */
            .border-width-1 {
                border-width: 3px;
            }

            .border-width-2 {
                border-width: 5px;
            }

            .grey-fg {
                
                border-color: var(--neutrals-grey-05, grey)
            }

            .blue-fg {
                border-color: var(--primary-blue-300, blue);
            }

            .grey-bg-1 {
                border-color: var(--neutrals-grey-10, white);
            }

            .grey-bg-2 {
                border-color: var(--functional-grey-200, grey)
            }
        `];
    }

    render()
    {
        return html`
            <div class="container">
                <div class="circle bg ${this.options?.colorBg} ${this.options?.borderWidth}"></div>
                <div class="circleClipper">
                    <div class="circle ${this.options?.colorFg} ${this.options?.borderWidth}" ?transparent=${this.transparent} ></div>
                </div>
            </div>
       `;
    }
}

